<template>
  <div class="body">
    <div class="left-nav">
      <div class="logo">
        <svg
          width="184px"
          height="40px"
          viewBox="0 0 184 40"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <!-- Generator: Sketch 53 (72520) - https://sketchapp.com -->
          <title>logo/blue</title>
          <desc>Created with Sketch.</desc>
          <defs>
            <linearGradient
              x1="63.4918398%"
              y1="43.4125221%"
              x2="63.4918398%"
              y2="84.342666%"
              id="linearGradient-1"
            >
              <stop stop-color="#FD9620" offset="0%" />
              <stop stop-color="#FE5C38" offset="100%" />
            </linearGradient>
            <linearGradient
              x1="53.0341797%"
              y1="49.3742533%"
              x2="51.6550862%"
              y2="51.4986666%"
              id="linearGradient-2"
            >
              <stop stop-color="#156EC9" offset="0%" />
              <stop stop-color="#1D326A" offset="100%" />
            </linearGradient>
          </defs>
          <g id="logo/blue" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <path
              d="M48.3912028,29.9163832 C48.7096489,29.9696587 49.1373038,30.0405555 49.6741674,30.1290737 C49.3410304,31.0759672 48.8151137,31.7968868 48.0964016,32.2918539 C47.3776894,32.786821 46.4785415,33.0343008 45.398931,33.0343008 C43.6900617,33.0343008 42.425394,32.4778554 41.60489,31.3649481 C40.9571237,30.4733924 40.6332454,29.3482046 40.6332454,27.9893508 C40.6332454,26.3661047 41.058914,25.0948884 41.910264,24.1756638 C42.7616141,23.2564392 43.8381239,22.7968338 45.1398258,22.7968338 C46.6019269,22.7968338 47.7555506,23.2779592 48.6007314,24.2402244 C49.4459122,25.2024896 49.849989,26.6766086 49.8129738,28.6626257 L43.2983278,28.6626257 C43.3168354,29.4312081 43.5265852,30.0291563 43.9275834,30.4564882 C44.3285816,30.88382 44.8282796,31.0974827 45.4266923,31.0974827 C45.8338597,31.0974827 46.1762453,30.9868085 46.4538595,30.7654567 C46.5894393,30.6648735 46.8099907,30.4924203 47.1155138,30.2480972 C47.4742576,29.9612144 47.938153,29.8405888 48.3912028,29.9163832 L48.3912028,29.9163832 Z M47.176781,27.1240106 C47.0342183,26.2340021 46.8389676,25.6574125 46.591029,25.3942419 C46.2191211,24.9994859 45.76664,24.8021108 45.2335721,24.8021108 C44.6633133,24.8021108 44.1922371,25.0103648 43.8203292,25.426879 C43.5723906,25.7045552 43.3895368,26.2702657 43.2717678,27.1240106 L47.176781,27.1240106 Z M51.8205805,32.0844327 L51.8205805,19.6306069 L53.3624234,19.6306069 C53.9453096,19.6306069 54.4178323,20.1031296 54.4178323,20.6860158 L54.4178323,26.7999007 L57.1436298,23.7106132 C57.3439774,23.4835488 57.6322053,23.3534792 57.935021,23.3534792 L60.1692385,23.3534792 C60.2858157,23.3534792 60.3803202,23.4479838 60.3803202,23.564561 C60.3803202,23.6182232 60.3598821,23.6698708 60.3231617,23.7090019 L57.3016137,26.9289111 L60.8970976,33.1398417 L58.7143258,33.1398417 C58.3327307,33.1398417 57.9808544,32.9338576 57.7940409,32.6011181 L55.6286508,28.7442721 L54.4178323,30.0067313 L54.4178323,33.1398417 L52.8759894,33.1398417 C52.2931032,33.1398417 51.8205805,32.667319 51.8205805,32.0844327 Z M62.2691293,32.0844327 L62.2691293,19.6306069 L63.8109722,19.6306069 C64.3938584,19.6306069 64.8663811,20.1031296 64.8663811,20.6860158 L64.8663811,26.7999007 L67.5921786,23.7106132 C67.7925262,23.4835488 68.0807541,23.3534792 68.3835699,23.3534792 L70.6177873,23.3534792 C70.7343645,23.3534792 70.8288691,23.4479838 70.8288691,23.564561 C70.8288691,23.6182232 70.8084309,23.6698708 70.7717105,23.7090019 L67.7501626,26.9289111 L71.3456464,33.1398417 L69.1628746,33.1398417 C68.7812795,33.1398417 68.4294032,32.9338576 68.2425897,32.6011181 L66.0771996,28.7442721 L64.8663811,30.0067313 L64.8663811,33.1398417 L63.3245383,33.1398417 C62.741652,33.1398417 62.2691293,32.667319 62.2691293,32.0844327 Z M72.2955145,27.9883049 C72.2955145,27.1274926 72.5081349,26.2943617 72.9333821,25.4888873 C73.3586293,24.6834129 73.9610538,24.0685562 74.7406737,23.6442987 C75.5202936,23.2200411 76.3908047,23.0079156 77.3522331,23.0079156 C78.8375168,23.0079156 80.0546916,23.489041 81.0037941,24.4513062 C81.9528965,25.4135714 82.4274406,26.6294506 82.4274406,28.0989802 C82.4274406,29.5808072 81.9482743,30.8089835 80.9899274,31.7835461 C80.0315804,32.7581086 78.8251907,33.2453826 77.370722,33.2453826 C76.4709236,33.2453826 75.6127383,33.0424799 74.7961404,32.6366683 C73.9795426,32.2308568 73.3586293,31.6359829 72.9333821,30.8520288 C72.5081349,30.0680747 72.2955145,29.1135096 72.2955145,27.9883049 Z M74.9340369,28.1266491 C74.9340369,29.0985367 75.1628083,29.8428192 75.6203578,30.3595189 C76.0779073,30.8762187 76.64221,31.1345646 77.3132826,31.1345646 C77.9843552,31.1345646 78.5471327,30.8762187 79.0016319,30.3595189 C79.4561311,29.8428192 79.6833773,29.0923856 79.6833773,28.1081956 C79.6833773,27.1486104 79.4561311,26.410479 79.0016319,25.8937792 C78.5471327,25.3770795 77.9843552,25.1187335 77.3132826,25.1187335 C76.64221,25.1187335 76.0779073,25.3770795 75.6203578,25.8937792 C75.1628083,26.410479 74.9340369,27.1547615 74.9340369,28.1266491 Z M41.8029638,22.6127931 C41.5423211,22.8109156 41.2954691,23.0359731 41.0630748,23.2877494 C39.9952623,24.4446185 39.4722955,26.0117217 39.4722955,27.9398574 C39.4722955,29.4880516 39.8347325,30.8170101 40.5712616,31.9015377 C38.6687215,35.0562783 35.2076755,37.1661045 31.2535944,37.1661045 C27.7745231,37.1661045 24.677144,35.5327434 22.6872202,32.9914036 C21.2201727,31.5111408 18.0834805,32.8427232 16.1568044,33.4364623 C14.20346,34.0384198 12.4952975,34.4228293 11.9329618,35.8549888 C11.9163348,35.9033644 11.8990648,35.9516452 11.8811482,35.9998209 C11.8741642,36.0205627 11.867032,36.0394323 11.8597594,36.0564801 C11.8077754,36.1921682 11.7506319,36.3269879 11.6882446,36.4607075 C10.2573317,39.5277 6.60975349,40.8546132 3.54115074,39.4244511 C0.472547987,37.994289 -0.855061898,34.348625 0.575851065,31.2816325 C2.00676403,28.21464 5.65434221,26.8877268 8.72294496,28.3178889 C9.64424926,28.7472747 10.4086178,29.3763692 10.9885125,30.1295517 C10.9976631,30.1381512 11.0070468,30.1477301 11.0166671,30.1583095 C11.9507502,31.1855201 12.4435997,30.9904391 15.4364243,30.1583095 C18.4292488,29.3261799 20.3820239,28.9659776 20.3820239,26.5988782 C20.3820239,26.5674957 20.382703,26.5384277 20.3840399,26.511614 C20.3826979,26.441317 20.3820239,26.3708567 20.3820239,26.300239 C20.3820239,26.1504415 20.3850568,26.0013519 20.3910644,25.8530283 C20.3851169,25.8180411 20.3820239,25.7726702 20.3820239,25.7162012 C20.3820239,24.0429554 18.694771,23.3200355 15.9680028,22.1668535 C13.2412347,21.0136715 12.9813904,20.7733058 11.5228741,21.343208 C11.4824228,21.359014 11.446345,21.3695401 11.4144321,21.3750919 C10.3979763,21.8710753 9.21762114,22.052911 8.02173445,21.8205762 C5.0969477,21.2523535 3.18681686,18.4219542 3.75533781,15.4987022 C4.32385877,12.5754503 7.15574419,10.6663218 10.0805309,11.2345444 C12.7795702,11.7589092 14.6145397,14.2097186 14.4349443,16.8821882 C14.5719008,17.9675306 14.8904547,18.2764336 17.2764747,19.4630408 C19.732548,20.6844866 21.5584002,20.8640764 22.3280301,20.0912635 C22.3307794,20.0885029 22.3334842,20.0858551 22.3361448,20.0833193 C22.7741203,19.4569217 23.2764801,18.8788156 23.8336304,18.3585897 C24.7154525,17.0422675 23.8095597,15.1293361 23.2341512,13.1132141 C22.6978169,11.2340004 21.5608822,10.1477258 20.623787,9.91156013 C18.0400457,9.52332117 16.1717461,7.18659784 16.4025796,4.54954394 C16.6425897,1.8076554 19.0610632,-0.220619902 21.8043913,0.0192642623 C24.5477194,0.259148426 26.5770596,2.6763528 26.3370495,5.41824134 C26.2504698,6.40733255 25.8804095,7.30356219 25.3138803,8.03395709 C24.8474519,8.77281221 25.0693107,10.6455452 25.8499579,12.2551331 C26.6630233,13.931563 27.4419977,15.9514749 28.81038,15.7098563 C29.5957191,15.5296051 30.4135296,15.4343735 31.2535944,15.4343735 C31.377254,15.4343735 31.5004314,15.436437 31.623094,15.4405315 C31.6497215,15.4374876 31.6801536,15.4354194 31.7145394,15.4343735 C33.4863562,15.3804801 33.9922583,14.3702537 34.5749755,12.6459551 C35.1368127,10.9834416 34.7366084,10.3372128 34.2515223,9.78562331 C33.4581073,8.9629021 32.9701581,7.84388643 32.9701581,6.61096393 C32.9701581,4.08420527 35.0195762,2.03586267 37.5476615,2.03586267 C40.0757468,2.03586267 42.1251648,4.08420527 42.1251648,6.61096393 C42.1251648,8.68506545 40.7442622,10.4368091 38.8512294,10.9978784 C38.8458821,11.0000237 38.8402751,11.0021263 38.8344055,11.0041854 C37.8713854,11.3420179 37.0623866,11.7588685 36.8228226,13.1480464 C36.5832586,14.5372244 36.2881168,16.524414 37.4782665,17.390341 C37.4808755,17.3922392 37.4834368,17.39412 37.4859507,17.3959834 C38.0952851,17.822818 38.6587966,18.3105439 39.1676421,18.8503225 C39.1794234,18.8494393 39.1988775,18.8625201 39.2267474,18.8910938 C39.8182745,19.497559 41.0270159,19.3615837 42.6440684,18.3051646 C44.2611209,17.2487455 44.5116831,16.853387 44.4374122,15.9773095 C44.4366007,15.9677374 44.4362366,15.9588244 44.4363093,15.9505569 C44.4215044,15.8077469 44.4139165,15.662795 44.4139165,15.5160718 C44.4139165,13.2149165 46.2803508,11.3494617 48.5827142,11.3494617 C50.8850776,11.3494617 52.7515119,13.2149165 52.7515119,15.5160718 C52.7515119,17.817227 50.8850776,19.6826818 48.5827142,19.6826818 C48.0849233,19.6826818 47.6075104,19.5954789 47.1649336,19.4355236 C46.3503399,19.2018296 44.8545432,19.6258682 43.7895648,20.3845446 C42.9273978,20.9987408 42.0758905,21.7199916 41.8029638,22.6127931 L41.8029638,22.6127931 Z M31.4751284,28.1409904 L34.658907,28.1409904 L34.658907,28.5910941 C34.658907,29.420123 34.1736157,30.1723924 33.4183199,30.5141776 C33.3242275,30.5567562 33.2353018,30.5937999 33.1515428,30.6253089 C32.5661253,30.845535 31.9822819,30.9556464 31.399995,30.9556464 C30.2228989,30.9556464 29.2712185,30.5619605 28.5449251,29.7745769 C27.8186318,28.9871933 27.4554906,27.8061357 27.4554906,26.2313685 C27.4554906,24.7712395 27.813936,23.6701258 28.5308376,22.9279941 C29.2477392,22.1858624 30.213507,21.8148022 31.42817,21.8148022 C32.2295972,21.8148022 32.8979648,22.0033491 33.4332931,22.3804485 C33.6818459,22.5555357 33.934194,22.8581702 34.1903373,23.2883521 C34.4154293,23.6663845 34.8514202,23.8651225 35.2844119,23.7870646 L37.2885766,23.4257628 C37.013086,22.2069775 36.3948068,21.2521761 35.4337204,20.56133 C34.4726339,19.8704838 33.1374638,19.525066 31.42817,19.525066 C30.1133286,19.525066 29.0145134,19.7452887 28.1316913,20.1857408 C26.9733787,20.758932 26.0937004,21.5825047 25.49263,22.6564839 C24.8915597,23.730463 24.591029,24.9582803 24.591029,26.3399726 C24.591029,27.6130602 24.8602544,28.7911011 25.3987133,29.8741306 C25.9371721,30.9571602 26.7417178,31.7897832 27.8123743,32.3720247 C28.8830309,32.9542662 30.1383725,33.2453826 31.5784369,33.2453826 C32.7117049,33.2453826 33.8308686,33.0387352 34.9359615,32.6254342 C36.4581552,32.056139 37.4670192,30.6017152 37.4670192,28.9765472 L37.4670185,25.9055562 L32.5305374,25.9055562 C31.9476511,25.9055562 31.4751284,26.3780789 31.4751284,26.9609652 L31.4751284,28.1409904 Z"
              id="Shape"
              fill="url(#linearGradient-1)"
            />
            <path
              d="M86.335526,31.8958684 L83.4828496,19.9472296 L84.5896103,19.9472296 C85.5810276,19.9472296 86.4388384,20.637197 86.6513607,21.605568 L88.33299,29.2680146 L90.8135962,19.9472296 L92.4251894,19.9472296 C93.3930523,19.9472296 94.2369083,20.6054685 94.4725123,21.5442174 L96.450496,29.4253665 L98.5330944,19.9472296 L98.6066302,19.9472296 C99.7724027,19.9472296 100.717448,20.8922749 100.717448,22.0580475 C100.717448,22.2258634 100.697436,22.3930806 100.657835,22.5561571 L97.9962468,33.5165155 L96.7119419,33.5165155 C95.7554561,33.5165155 94.9185131,32.8733591 94.6722724,31.9491131 L92.387115,23.371947 L89.693621,33.5165155 L88.3886419,33.5165155 C87.4116903,33.5165155 86.5623922,32.8461138 86.335526,31.8958684 Z M101.741425,28.4104685 C101.741425,27.5496562 101.954045,26.7165253 102.379292,25.9110509 C102.80454,25.1055765 103.406964,24.4907198 104.186584,24.0664622 C104.966204,23.6422047 105.836715,23.4300792 106.798143,23.4300792 C108.283427,23.4300792 109.500602,23.9112046 110.449704,24.8734698 C111.398807,25.835735 111.873351,27.0516142 111.873351,28.5211438 C111.873351,30.0029708 111.394185,31.2311471 110.435838,32.2057097 C109.477491,33.1802722 108.271101,33.6675462 106.816632,33.6675462 C105.916834,33.6675462 105.058649,33.4646435 104.242051,33.0588319 C103.425453,32.6530204 102.80454,32.0581465 102.379292,31.2741924 C101.954045,30.4902383 101.741425,29.5356732 101.741425,28.4104685 Z M104.392138,28.6015831 C104.392138,29.5765526 104.623536,30.3231952 105.086338,30.8415334 C105.54914,31.3598717 106.11992,31.6190369 106.798696,31.6190369 C107.477472,31.6190369 108.04671,31.3598717 108.506427,30.8415334 C108.966144,30.3231952 109.195998,29.570382 109.195998,28.5830711 C109.195998,27.620443 108.966144,26.879971 108.506427,26.3616328 C108.04671,25.8432946 107.477472,25.5841294 106.798696,25.5841294 C106.11992,25.5841294 105.54914,25.8432946 105.086338,26.3616328 C104.623536,26.879971 104.392138,27.6266136 104.392138,28.6015831 Z M116.397161,33.5165155 L114.851636,33.5165155 C114.26875,33.5165155 113.796227,33.0439928 113.796227,32.4611065 L113.796227,23.6866508 L115.156632,23.6866508 C115.739519,23.6866508 116.212041,24.1591735 116.212041,24.7420597 L116.212041,25.0843057 C116.625478,24.4240416 116.997256,23.9890143 117.327388,23.7792107 C117.65752,23.5694071 118.023977,23.5215895 118.443584,23.5215895 C119.03597,23.5215895 119.770032,23.6866508 119.918608,24.00441 C119.992445,24.5794456 119.805936,25.3189065 119.359079,26.2227929 C118.92096,25.938941 118.5137,25.7970172 118.137288,25.7970172 C117.773217,25.7970172 117.464687,25.8972895 117.211689,26.097837 C116.95869,26.2983845 116.759688,26.6609073 116.614677,27.1854162 C116.469666,27.7099251 116.397161,28.8082919 116.397161,30.4805497 L116.397161,33.5165155 Z M121.191766,32.4611065 L121.191766,19.9472296 L122.737291,19.9472296 C123.320177,19.9472296 123.7927,20.4197522 123.7927,21.0026385 L123.7927,27.1483922 L126.522715,24.0449704 C126.723086,23.8171925 127.011784,23.6866508 127.315151,23.6866508 L129.553956,23.6866508 C129.670533,23.6866508 129.765038,23.7811553 129.765038,23.8977326 C129.765038,23.9512849 129.744683,24.0028353 129.708097,24.0419414 L126.680569,27.2779761 L130.281151,33.5165155 L128.095321,33.5165155 C127.71324,33.5165155 127.360994,33.3100106 127.174372,32.9766065 L125.005235,29.1014067 L123.7927,30.3694778 L123.7927,33.5165155 L122.247175,33.5165155 C121.664288,33.5165155 121.191766,33.0439928 121.191766,32.4611065 Z M130.910558,30.7119495 L132.381814,30.4876094 C132.988268,30.3951359 133.593554,30.6613539 133.935251,31.1708446 C134.02216,31.3004305 134.109221,31.3989199 134.196436,31.466313 C134.535824,31.7285674 135.01096,31.8596927 135.621859,31.8596927 C136.294464,31.8596927 136.800454,31.7362807 137.139842,31.489453 C137.368157,31.3166736 137.482313,31.085276 137.482313,30.7952535 C137.482313,30.5977913 137.420607,30.4342704 137.297194,30.3046858 C137.167609,30.181272 136.877591,30.0671159 136.42713,29.9622141 C134.329095,29.4994121 132.99933,29.076726 132.437797,28.694143 C131.66029,28.1634635 131.271542,27.4260767 131.271542,26.4819607 C131.271542,25.6304051 131.60784,24.9146154 132.280445,24.3345703 C132.953051,23.7545252 133.995882,23.4645069 135.408971,23.4645069 C136.754182,23.4645069 137.753819,23.6835632 138.407913,24.1216824 C139.062006,24.5598016 139.51246,25.2077147 139.759288,26.065441 L138.368996,26.3225137 C137.816278,26.4247145 137.250813,26.2261767 136.883302,25.8008787 C136.825034,25.7334488 136.76708,25.679711 136.709438,25.6396653 C136.41633,25.4360325 135.998272,25.3342175 135.455251,25.3342175 C134.770304,25.3342175 134.279741,25.4298618 133.983548,25.6211533 C133.786086,25.7569086 133.687356,25.9327707 133.687356,26.1487449 C133.687356,26.3338657 133.773745,26.491216 133.946524,26.6208006 C134.18101,26.79358 134.990902,27.0373187 136.376222,27.352024 C137.761543,27.6667294 138.728784,28.0523919 139.277976,28.5090232 C139.820997,28.9718252 140.092503,29.6166529 140.092503,30.4435257 C140.092503,31.3444469 139.716097,32.1188573 138.963272,32.76678 C138.210448,33.4147028 137.096654,33.7386593 135.621859,33.7386593 C134.282818,33.7386593 133.223018,33.4671529 132.442425,32.9241319 C131.661833,32.3811109 131.151215,31.6437242 130.910558,30.7119495 Z M142.29543,23.6866508 L143.665091,23.6866508 C144.247977,23.6866508 144.7205,24.1591735 144.7205,24.7420597 L144.7205,25.1305857 C145.035205,24.6369303 145.460977,24.2358412 145.997827,23.9273066 C146.534677,23.6187719 147.13014,23.4645069 147.784234,23.4645069 C148.925812,23.4645069 149.894596,23.9118755 150.690616,24.8066259 C151.486635,25.7013764 151.884639,26.9478377 151.884639,28.5460472 C151.884639,30.1874515 151.48355,31.4632231 150.68136,32.3734003 C149.87917,33.2835775 148.9073,33.7386593 147.765722,33.7386593 C147.222701,33.7386593 146.730595,33.6306738 146.289391,33.4146995 C145.848186,33.1987253 145.383849,32.8284893 144.896364,32.3039804 L144.896364,37.2559367 L143.350839,37.2559367 C142.767953,37.2559367 142.29543,36.783414 142.29543,36.2005277 L142.29543,23.6866508 Z M144.868596,28.4349752 C144.868596,29.5395293 145.087652,30.3555912 145.525771,30.8831854 C145.963891,31.4107797 146.497648,31.6745728 147.127058,31.6745728 C147.731786,31.6745728 148.23469,31.4323768 148.635785,30.9479774 C149.03688,30.463578 149.237425,29.6691132 149.237425,28.5645591 C149.237425,27.5340534 149.03071,26.768899 148.617273,26.2690728 C148.203837,25.7692467 147.691677,25.5193374 147.080778,25.5193374 C146.445197,25.5193374 145.917611,25.7646188 145.498003,26.2551889 C145.078396,26.7457589 144.868596,27.4723471 144.868596,28.4349752 Z M155.143877,26.5505498 L153.532205,26.2598169 C153.797545,25.3095301 154.25417,24.6060817 154.902092,24.1494504 C155.550015,23.6928191 156.512629,23.4645069 157.789962,23.4645069 C158.950053,23.4645069 159.813937,23.6018028 160.38164,23.8763986 C160.949344,24.1509945 161.348891,24.4996334 161.580292,24.9223259 C161.811692,25.3450183 161.927391,26.1209713 161.927391,27.2502081 L161.899623,30.2861739 C161.899623,31.1500709 161.941275,31.7871854 162.024579,32.1975364 C162.107884,32.6078875 162.263691,33.0475428 162.492007,33.5165155 L160.692514,33.5165155 C160.218453,33.5165155 159.801348,33.2034596 159.668929,32.748268 C159.625734,32.5940007 159.594881,32.4921858 159.576369,32.4428203 C159.132079,32.8747688 158.656943,33.1987253 158.150946,33.4146995 C157.644949,33.6306738 157.105022,33.7386593 156.531147,33.7386593 C155.519154,33.7386593 154.721604,33.4640676 154.138473,32.9148759 C153.555343,32.3656842 153.263782,31.6714917 153.263782,30.8322775 C153.263782,30.2769151 153.39645,29.7817244 153.661789,29.3466906 C153.927129,28.9116567 154.298908,28.5784443 154.777137,28.3470433 C155.255365,28.1156423 155.94493,27.9135552 156.845851,27.7407758 C158.061478,27.5124601 158.903764,27.2995744 159.372737,27.1021122 L159.372737,26.8429444 C159.372737,26.3431183 159.249325,25.9867661 159.002497,25.7738772 C158.75567,25.5609883 158.289789,25.4545455 157.604842,25.4545455 C157.14204,25.4545455 156.78106,25.5455618 156.521891,25.7275973 C156.431156,25.791328 156.33021,25.9096569 156.219054,26.0825839 C155.988261,26.4416327 155.563925,26.6263231 155.143877,26.5505498 Z M159.372737,28.795959 C159.03952,28.9070314 158.511933,29.0396993 157.789962,29.1939667 C157.067991,29.348234 156.59594,29.4994137 156.373795,29.6475103 C156.034407,29.8881674 155.864716,30.1936121 155.864716,30.5638537 C155.864716,30.9279245 156.000469,31.2426252 156.271979,31.507965 C156.54349,31.7733047 156.889044,31.9059727 157.308651,31.9059727 C157.777623,31.9059727 158.224992,31.7517076 158.65077,31.443173 C158.965475,31.2086867 159.17219,30.9217538 159.270921,30.5823656 C159.338799,30.3602207 159.372737,29.9375346 159.372737,29.3142946 L159.372737,28.795959 Z M173.062351,26.5930326 L172.047009,26.7763071 C171.283867,26.9140583 170.506642,26.6222659 170.022703,26.0163254 C169.985627,25.9699022 169.948288,25.9307381 169.910685,25.8988331 C169.605236,25.639664 169.208775,25.5100814 168.72129,25.5100814 C168.073367,25.5100814 167.55658,25.7337657 167.170911,26.1811409 C166.785243,26.6285162 166.592412,27.3767014 166.592412,28.4257192 C166.592412,29.5919802 166.788328,30.4157554 167.180167,30.8970694 C167.572006,31.3783835 168.09805,31.6190369 168.758314,31.6190369 C169.25197,31.6190369 169.656144,31.4786557 169.970849,31.1978892 C170.026501,31.1482388 170.083022,31.0777841 170.14041,30.9865251 C170.594898,30.2638012 171.439994,29.8860202 172.281628,30.0293419 L173.191935,30.1843579 C172.926595,31.3567896 172.417521,32.2422707 171.664696,32.840828 C170.911871,33.4393852 169.902978,33.7386593 168.637986,33.7386593 C167.200215,33.7386593 166.054026,33.2851202 165.199385,32.3780283 C164.344744,31.4709364 163.91743,30.2152193 163.91743,28.6108391 C163.91743,26.9879469 164.346286,25.7245164 165.204013,24.8205099 C166.061739,23.9165034 167.221812,23.4645069 168.684266,23.4645069 C169.881381,23.4645069 170.833196,23.7221295 171.53974,24.2373824 C172.246284,24.7526352 172.753816,25.5378441 173.062351,26.5930326 Z M181.51028,30.5195841 L183.317991,30.8230215 C182.984774,31.7733082 182.45873,32.4968111 181.739845,32.9935518 C181.020959,33.4902926 180.121594,33.7386593 179.041723,33.7386593 C177.332441,33.7386593 176.067468,33.18022 175.246765,32.0633245 C174.598843,31.1685741 174.274886,30.0393542 174.274886,28.6756311 C174.274886,27.0465681 174.700657,25.7707965 175.552213,24.8482779 C176.403769,23.9257593 177.480539,23.4645069 178.782555,23.4645069 C180.245009,23.4645069 181.398911,23.9473564 182.244296,24.9130699 C183.089681,25.8787833 183.493855,27.3581847 183.456831,29.3513186 L176.940612,29.3513186 C176.959124,30.1226552 177.168925,30.7227461 177.57002,31.1516092 C177.971115,31.5804724 178.470933,31.7949007 179.06949,31.7949007 C179.476756,31.7949007 179.819225,31.6838299 180.096906,31.461685 C180.196509,31.3820021 180.303258,31.2415827 180.417152,31.0404269 C180.635795,30.6542676 181.072641,30.4461234 181.51028,30.5195841 Z M180.874409,27.7592877 C180.855897,27.0064632 180.661523,26.43414 180.291282,26.042301 C179.92104,25.650462 179.470586,25.4545455 178.939907,25.4545455 C178.372203,25.4545455 177.903237,25.6612606 177.532996,26.074697 C177.162754,26.4881334 176.980721,27.0496581 176.986892,27.7592877 L180.874409,27.7592877 Z"
              id="Shape"
              fill="url(#linearGradient-2)"
              fill-rule="nonzero"
            />
          </g>
        </svg>
      </div>
      <ul class="nav">
        <li :class="{ active: navSelect == index }" v-for="(item, index) in navList" :key="index">
          <a @click="routerTo(index)">
            <span class="icon">{{ item.icon }}</span>
            <span>{{ $t(item.title) }}</span>
            <span
              class="addBtn icon"
              v-if="item.title == 'list.workspace.li2'"
              @click.stop="addCase"
            >&#xe983;</span>
            <span
              class="arrow icon"
              :class="{ up: showTags }"
              v-if="item.title == 'list.workspace.li3'"
              @click.stop="toggleTags($event)"
            >&#xe91c;</span>
          </a>
          <collapse>
            <div class="tagDiv" ref="tagDiv" v-if="item.title == 'list.workspace.li3' && showTags">
              <div class="tags">
                <div>
                  <span class="icon">&#xe95e;</span>
                  <span class="title">{{$t('content.tag')}}</span>
                </div>
                <div class="tags-wrapper">
                  <span
                    class="tag"
                    v-for="(item, index) in tags"
                    :key="index"
                    :class="{ select: tagBeSelected.includes(item) }"
                    @click="selectTag(index)"
                  >
                    <span>
                      <span></span>
                    </span>
                    <span class="text" :title="item">{{ item }}</span>
                  </span>
                </div>
              </div>
            </div>
          </collapse>
        </li>
      </ul>
      <div class="footer">
        <a @click="navTo('search')" :class="{disabled:searchDisable}">
          <span class="icon">
            <svg
              width="20px"
              height="20px"
              viewBox="0 0 512 512"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <!-- Generator: Sketch 53 (72520) - https://sketchapp.com -->
              <title>logo-g-blue</title>
              <desc>Created with Sketch.</desc>
              <defs>
                <linearGradient
                  x1="70.0850505%"
                  y1="33.9205855%"
                  x2="21.906812%"
                  y2="78.7282%"
                  id="linearGradient-2"
                >
                  <stop stop-color="#156EC9" offset="0%" />
                  <stop stop-color="#1D326A" offset="100%" />
                </linearGradient>
              </defs>
              <g id="logo-g-blue" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <path
                  d="M161.077863,380.474271 C142.933572,386.063747 127.066736,389.633181 121.843293,402.931499 C121.688847,403.38069 121.528429,403.829001 121.362005,404.276337 C121.297132,404.468935 121.230882,404.644149 121.163328,404.802446 C120.680457,406.062378 120.149661,407.314246 119.570156,408.5559 C106.278644,437.034458 72.3968983,449.355511 43.8931589,436.075741 C15.3894195,422.795971 3.05747258,388.944157 16.3489845,360.465598 C29.6404965,331.98704 63.5222422,319.665987 92.0259815,332.945757 C100.583824,336.932819 107.683916,342.774276 113.070461,349.767953 C113.155459,349.847803 113.242623,349.936748 113.331984,350.034983 C122.008526,359.573147 126.586524,357.761722 154.386372,350.034983 C182.18622,342.308244 200.325222,338.963585 200.325222,316.983883 C200.325222,316.692481 200.33153,316.42257 200.343948,316.173592 C200.331483,315.520849 200.325222,314.86659 200.325222,314.210869 C200.325222,312.819924 200.353394,311.435553 200.409198,310.058294 C200.353952,309.73342 200.325222,309.312129 200.325222,308.787786 C200.325222,293.250862 184.652611,286.538189 159.324116,275.830318 C133.995622,265.122447 131.581971,262.890531 118.034057,268.182358 C117.658311,268.329125 117.323191,268.426865 117.026757,268.478416 C107.585069,273.08387 96.6209462,274.772305 85.5125541,272.61496 C58.3446975,267.338729 40.6018106,241.057055 45.8827069,213.9132 C51.1636033,186.769344 77.4685149,169.042131 104.636371,174.318362 C129.707297,179.187351 146.752023,201.944342 145.083791,226.759559 C146.355957,236.837506 149.314951,239.705824 171.478294,250.724066 C194.292348,262.0658 211.252386,263.733381 218.401349,256.557428 C218.426887,256.531793 218.452011,256.507207 218.476726,256.483661 C222.545007,250.667246 227.211343,245.299243 232.386619,240.468685 C240.577718,228.245975 232.163031,210.48345 226.818157,191.762749 C221.836237,174.313311 211.275441,164.226708 202.570919,162.033792 C178.570977,158.428799 161.216654,136.731154 163.360827,112.24479 C165.590241,86.7849842 188.055038,67.9514339 213.537356,70.1788783 C239.019674,72.4063227 257.869876,94.8512739 255.640463,120.31108 C254.836238,129.495286 251.39881,137.817227 246.136414,144.599309 C241.803839,151.459948 243.864648,168.84921 251.115949,183.795038 C258.668378,199.361528 265.904142,218.11742 278.614817,215.87387 C285.909701,214.200148 293.506207,213.315875 301.309428,213.315875 C302.458081,213.315875 303.602256,213.335036 304.741648,213.373056 C304.988987,213.344791 305.271665,213.325587 305.591069,213.315875 C322.049181,212.815448 326.74842,203.434991 332.161183,187.424016 C337.379996,171.986747 333.662565,165.986189 329.15668,160.864405 C321.786781,153.225027 317.254303,142.834407 317.254303,131.386106 C317.254303,107.923888 336.291005,88.9040028 359.773968,88.9040028 C383.256931,88.9040028 402.293634,107.923888 402.293634,131.386106 C402.293634,150.645175 389.466659,166.910991 371.882593,172.1208 C371.832923,172.14072 371.780841,172.160244 371.726318,172.179364 C362.780986,175.316307 355.26633,179.186973 353.04106,192.086185 C350.81579,204.985397 348.074268,223.437446 359.12937,231.478011 C359.153604,231.495637 359.177396,231.513101 359.200747,231.530403 C364.860752,235.493776 370.095117,240.022555 374.821698,245.034669 C374.931133,245.026468 375.111838,245.14793 375.370717,245.413251 C380.865314,251.044584 392.093112,249.781986 407.113643,239.972606 C422.134174,230.163226 424.461604,226.492125 423.771714,218.357308 C423.764176,218.268425 423.760794,218.185664 423.761469,218.108896 C423.623949,216.782834 423.553466,215.436883 423.553466,214.074484 C423.553466,192.707108 440.890463,175.385426 462.276733,175.385426 C483.663003,175.385426 501,192.707108 501,214.074484 C501,235.441861 483.663003,252.763542 462.276733,252.763542 C457.652836,252.763542 453.218228,251.95382 449.107205,250.468554 C441.540581,248.298589 427.646374,252.235999 417.753967,259.280689 C407.674189,266.458812 397.751266,275.211668 398.503473,286.733343 C400.972554,295.468953 402.293634,304.68577 402.293634,314.210869 C402.293634,369.933636 357.081465,415.105864 301.309428,415.105864 C268.992915,415.105864 240.221877,399.939289 221.737806,376.341678 C208.110647,362.596698 178.974436,374.961107 161.077863,380.474271 Z M306.202302,331.303166 L335.765277,331.303166 L335.765277,335.223347 C335.765277,343.141794 331.093518,350.31463 323.851059,353.515973 C323.122412,353.838052 322.428275,354.123163 321.768648,354.371306 C316.332754,356.416215 310.911476,357.438654 305.504651,357.438654 C294.574726,357.438654 285.737897,353.783084 278.993901,346.471834 C272.249904,339.160583 268.877957,328.193873 268.877957,313.571372 C268.877957,300.013345 272.206302,289.788953 278.863091,282.897889 C285.519881,276.006826 294.487518,272.561346 305.76627,272.561346 C313.207922,272.561346 319.414049,274.312098 324.38484,277.813654 C326.67327,279.425685 328.996348,282.202122 331.354074,286.142964 C333.490394,289.713736 337.614631,291.588459 341.709664,290.850224 L360.183073,287.519921 C357.625006,276.20289 351.883974,267.337081 342.959806,260.92223 C334.035639,254.507378 321.637917,251.3 305.76627,251.3 C293.557311,251.3 283.354263,253.344878 275.156819,257.434697 C264.401307,262.757063 256.233054,270.404348 250.651816,280.376781 C245.070577,290.349214 242.28,301.750112 242.28,314.579815 C242.28,326.401071 244.779892,337.339769 249.779752,347.39624 C254.779611,357.452711 262.250219,365.184032 272.1918,370.590435 C282.133381,375.996839 293.789856,378.7 307.161573,378.7 C317.684533,378.7 328.076527,376.781176 338.337866,372.94347 C352.472196,367.657278 361.840002,354.152226 361.840002,339.061729 L361.839995,310.546042 L316.202302,310.546042 C310.679455,310.546042 306.202302,315.023195 306.202302,320.546042 L306.202302,331.303166 Z"
                  id="Combined-Shape-Copy"
                  fill="url(#linearGradient-2)"
                />
              </g>
            </svg>
          </span>
          <span>Gekko Search</span>
        </a>
        <a @click="navTo('graph')" :class="{disabled:graphDisable}">
          <span class="icon">
            <svg
              width="20px"
              height="20px"
              viewBox="0 0 512 512"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <!-- Generator: Sketch 53 (72520) - https://sketchapp.com -->
              <title>logo-g-yellow</title>
              <desc>Created with Sketch.</desc>
              <defs>
                <linearGradient
                  x1="58.1435171%"
                  y1="31.7288908%"
                  x2="40.9269486%"
                  y2="80.8680985%"
                  id="linearGradient-1"
                >
                  <stop stop-color="#FD9620" offset="0%" />
                  <stop stop-color="#FE5C38" offset="100%" />
                </linearGradient>
              </defs>
              <g id="logo-g-yellow" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <path
                  d="M161.077863,382.220978 C142.933572,387.859903 127.066736,391.460915 121.843293,404.87688 C121.688847,405.330046 121.528429,405.782323 121.362005,406.233617 C121.297132,406.427918 121.230882,406.604682 121.163328,406.76438 C120.680457,408.035458 120.149661,409.298401 119.570156,410.551039 C106.278644,439.281543 72.3968983,451.711597 43.8931589,438.314344 C15.3894195,424.91709 3.05747258,390.765796 16.3489845,362.035293 C29.6404965,333.304789 63.5222422,320.874735 92.0259815,334.271988 C100.583824,338.294323 107.683916,344.187459 113.070461,351.243007 C113.155459,351.323563 113.242623,351.413295 113.331984,351.512399 C122.008526,361.134946 126.586524,359.307496 154.386372,351.512399 C182.18622,343.717303 200.325222,340.343055 200.325222,318.168903 C200.325222,317.874923 200.33153,317.602624 200.343948,317.351443 C200.331483,316.692926 200.325222,316.032878 200.325222,315.371357 C200.325222,313.968106 200.353394,312.571488 200.409198,311.182045 C200.353952,310.854296 200.325222,310.429278 200.325222,309.900297 C200.325222,294.22592 184.652611,287.453862 159.324116,276.65126 C133.995622,265.848658 131.581971,263.596997 118.034057,268.93564 C117.658311,269.083705 117.323191,269.18231 117.026757,269.234317 C107.585069,273.880514 96.6209462,275.583887 85.5125541,273.407456 C58.3446975,268.084547 40.6018106,241.570365 45.8827069,214.186372 C51.1636033,186.80238 77.4685149,168.918338 104.636371,174.241247 C129.707297,179.153311 146.752023,202.111628 145.083791,227.146381 C146.355957,237.313485 149.314951,240.20718 171.478294,251.322897 C194.292348,262.76497 211.252386,264.447304 218.401349,257.207866 C218.426887,257.182005 218.452011,257.157201 218.476726,257.133447 C222.545007,251.265575 227.211343,245.850082 232.386619,240.976789 C240.577718,228.645947 232.163031,210.726281 226.818157,191.839961 C221.836237,174.236151 211.275441,164.060314 202.570919,161.847997 C178.570977,158.211112 161.216654,136.321512 163.360827,111.618522 C165.590241,85.9334778 188.055038,66.9333106 213.537356,69.1804608 C239.019674,71.427611 257.869876,94.0711284 255.640463,119.756173 C254.836238,129.02163 251.39881,137.417193 246.136414,144.259275 C241.803839,151.180608 243.864648,168.72371 251.115949,183.801761 C258.668378,199.505965 265.904142,218.427787 278.614817,216.164389 C285.909701,214.47586 293.506207,213.583764 301.309428,213.583764 C302.458081,213.583764 303.602256,213.603094 304.741648,213.64145 C304.988987,213.612935 305.271665,213.593561 305.591069,213.583764 C322.049181,213.078909 326.74842,203.615465 332.161183,187.462844 C337.379996,171.889005 333.662565,165.835361 329.15668,160.668265 C321.786781,152.961304 317.254303,142.47876 317.254303,130.929177 C317.254303,107.259394 336.291005,88.0712429 359.773968,88.0712429 C383.256931,88.0712429 402.293634,107.259394 402.293634,130.929177 C402.293634,150.358628 389.466659,166.768344 371.882593,172.024243 C371.832923,172.04434 371.780841,172.064036 371.726318,172.083325 C362.780986,175.248021 355.26633,179.152929 353.04106,192.166258 C350.81579,205.179587 348.074268,223.794878 359.12937,231.906576 C359.153604,231.924358 359.177396,231.941977 359.200747,231.959432 C364.860752,235.957868 370.095117,240.526713 374.821698,245.583168 C374.931133,245.574894 375.111838,245.697431 375.370717,245.965099 C380.865314,251.646251 392.093112,250.372483 407.113643,240.476321 C422.134174,230.58016 424.461604,226.876581 423.771714,218.669797 C423.764176,218.580128 423.760794,218.496634 423.761469,218.419187 C423.623949,217.081394 423.553466,215.723535 423.553466,214.349084 C423.553466,192.792674 440.890463,175.317751 462.276733,175.317751 C483.663003,175.317751 501,192.792674 501,214.349084 C501,235.905494 483.663003,253.380417 462.276733,253.380417 C457.652836,253.380417 453.218228,252.563531 449.107205,251.065125 C441.540581,248.875963 427.646374,252.848207 417.753967,259.955219 C407.674189,267.196845 397.751266,276.027137 398.503473,287.650742 C400.972554,296.463634 402.293634,305.761991 402.293634,315.371357 C402.293634,371.587092 357.081465,417.15895 301.309428,417.15895 C268.992915,417.15895 240.221877,401.8582 221.737806,378.051825 C208.110647,364.185246 178.974436,376.65904 161.077863,382.220978 Z M307.0824,330.598246 L337.372334,330.598246 L337.372319,333.451668 C337.372319,342.637451 331.65743,350.859518 323.031525,354.083909 C317.461961,356.16583 311.907373,357.206775 306.367593,357.206775 C295.168899,357.206775 286.114771,353.48504 279.204938,346.04146 C272.295106,338.597879 268.840241,327.432676 268.840241,312.545515 C268.840241,298.742093 272.250431,288.332644 279.070912,281.316856 C285.891394,274.301067 295.079546,270.793225 306.635646,270.793225 C314.260289,270.793225 320.619027,272.575665 325.71205,276.140598 C327.829286,277.622587 329.975468,280.0712 332.150596,283.486436 C334.900376,287.803951 339.995885,290.034188 345.044313,289.129845 L362.390569,286.022544 C359.769598,274.50068 353.887394,265.474404 344.743779,258.943446 C335.600164,252.412489 322.89758,249.147059 306.635646,249.147059 C294.126466,249.147059 283.672522,251.228949 275.273502,255.392791 C264.25351,260.811489 255.884398,268.597187 250.165916,278.750116 C244.447434,288.903046 241.588235,300.510295 241.588235,313.57221 C241.588235,325.607425 244.1496,336.744109 249.272407,346.982597 C254.395214,357.221086 262.049526,365.09234 272.235573,370.596597 C282.42162,376.100854 294.364729,378.852941 308.065259,378.852941 C318.846981,378.852941 329.494516,376.899387 340.008184,372.99222 C354.486908,367.61153 364.088222,353.826231 364.088222,338.418774 L364.088235,309.465428 L319.711267,309.465428 C312.736536,309.465428 307.0824,315.103418 307.0824,322.058232 L307.0824,330.598246 Z"
                  id="Shape"
                  fill="url(#linearGradient-1)"
                />
              </g>
            </svg>
          </span>
          <span>Gekko Graph</span>
        </a>
        <a :class="{ active: showAcountCloset }" @click.stop.prevent="showCloset">
          <closet :ifShow="showAcountCloset" @closeAccount="hideCloset"></closet>
          <span class="icon">&#xe914;</span>
          <span>{{ $t("account") }}</span>
        </a>
        <span class="copyright">
          <span @click="navTo('copyright')">Terms and Conditions</span>
          <span>©️2019 Gekko Lab.All rights reserved.</span>
        </span>
      </div>
    </div>
    <div class="main-part" id="main-part">
      <div class="top-nav">
        <edit-panel @search="search" @refresh="refresh" :refreshing="refreshing"></edit-panel>
      </div>
      <div class="bread-crumbs">
        <span>{{ $t("list.workspace") }}</span>
        <span
          v-for="(item, index) in breadCrumbs"
          :key="index"
          @click="bcRouter(index)"
        >{{ $t(item) }}</span>
        <span
          v-if="tagNowSelect.length !== 0 || curPath[0] == 'search'"
        >{{ curPath[0] == "search" ? "Search KeyWord" : "Search Tag" }}:</span>

        <!-- tag -->
        <span class="tagSearch" v-for="item in tagNowSelect" :key="item">
          {{ item }}
          <a class="close" @click="tagSelect(tags.indexOf(item))">&#xe931;</a>
        </span>

        <!-- keyword -->
        <span class="tagSearch" v-if="keyWord">
          {{ keyWord }}
          <a class="close" @click="clearKeyword">&#xe931;</a>
        </span>
      </div>
      <!-- content -->
      <div class="content">
        <router-view></router-view>
      </div>
    </div>
    <loading-page v-if="!hideLoading" :loading="loading"></loading-page>
  </div>
</template>

<script>
import editPanel from "@/components/editPanel";
import closet from "@/components/closet";
import loadingPage from "@/components/loadingPage";
import collapse from "@/components/transition";
import { mapState, mapMutations, mapGetters, mapActions } from "vuex";
import { resolve } from "q";
let map = ["all", "case", "doc", "graph"];
export default {
  components: {
    editPanel,
    closet,
    loadingPage,
    collapse
  },
  data() {
    return {
      navList: [
        { icon: "\ue97d", activeIcon: "", title: "list.workspace.li1" },
        { icon: "\ue92d", activeIcon: "", title: "list.workspace.li2" },
        { icon: "\ue9ac", activeIcon: "", title: "list.workspace.li3" },
        { icon: "\ue908", activeIcon: "", title: "list.workspace.li4" }
      ],
      showTags: true,
      showAcountCloset: false,
      loading: false,
      hideLoading: true,
      tagHeight: 0,
      graphDisable: true,
      searchDisable: true,
      refreshing: false
    };
  },
  computed: {
    ...mapState(["tags", "tagBeSelected", "keyWord", "requestPending"]),
    ...mapGetters(["tagNowSelect"]),
    /**
     *@returns {string} all|case|doc|graph
     */
    navSelect() {
      let url = this.curPath[0];
      return map.indexOf(url);
    },
    /**
     * @returns {Array} route path array
     */
    curPath() {
      let path = this.$route.path;
      let pathArr = path.split("/").slice(1);
      return pathArr;
    },
    /**
     * @returns {Array} content shown on bread crumb
     */
    breadCrumbs() {
      let bc = [];
      let url = this.$route.path.split("/").slice(1);
      let firstLevel = url.shift();
      if (this.curPath[0] !== "search") {
        let content = this.navList[map.indexOf(firstLevel)].title;
        bc.push(content);
        while (url.length && url[0] !== "tag") {
          bc.push(url.shift());
        }
      }

      return bc;
    }
  },
  methods: {
    ...mapMutations(["tagSelect", "clearTagSelect", "clearKeyword"]),
    ...mapActions(["createCase", "getWorkSpace"]),
    /**
     * navigate to the different content by left nav
     * @param {Number} index -index of selection
     */
    routerTo(index) {
      let path = `/${map[index]}`;
      if (this.navSelect !== index) {
        this.routerHandle(path);
      }
    },
    /**
     * navigate to search ,graph or copyright
     * @param {String} product -search|graph|copyright
     */
    navTo(product) {
      if (product == "graph" && !this.graphDisable) {
        window.open(this.$graph_client);
      } else if (product == "search" && !this.searchDisable) {
        window.open(this.$search_client);
      } else if (product == "copyright") {
        window.open("https://gekko.ai/policies/terms");
      } else {
        return;
      }
    },
    toggleTags() {
      this.showTags = !this.showTags;
    },
    /**
     * Clear the selected tags or keywords before navigating
     * @param {String} path -target path
     */
    routerHandle(path) {
      if (this.curPath[1] == "tag") {
        this.clearTagSelect();
        this.$nextTick(function() {
          if (path !== "/doc") {
            this.$router.replace(path);
          }
        });
      } else if (this.curPath[0] == "search") {
        this.clearKeyword();
        this.$nextTick(function() {
          if (path !== "/all") {
            this.$router.replace(path);
          }
        });
      } else {
        this.$router.replace(path);
      }
    },
    refresh() {
      this.refreshing = true;
      this.getWorkSpace().then(() => {
        this.refreshing = false;
        this.$toast();
      });
    },
    showCloset() {
      this.showAcountCloset = true;
      document.addEventListener("click", this.hideCloset);
    },
    hideCloset() {
      this.showAcountCloset = false;
      document.removeEventListener("click", this.hideCloset);
    },
    /**
     * select tag and navigate to /doc/tag
     * @param {Number} index - index of selected tag
     */
    selectTag(index) {
      this.tagSelect(index);
      let path = "/doc/tag";
      if (this.curPath[1] !== "tag") {
        this.routerHandle(path);
      }
    },
    /**
     * Navigate to /search
     * @param {String} value - keyword be searched
     */
    search(value) {
      let path = "/search";
      if (value !== "" && this.curPath[0] !== "search") {
        this.routerHandle(path);
      }
    },
    /**
     * navigate to target by click bread crumb
     */
    bcRouter(index) {
      if (index == 0 && this.curPath.length > 1) {
        let path = `/${this.curPath[index]}`;
        this.routerHandle(path);
      }
    },
    /**create case */
    addCase() {
      if (this.requestPending) {
        this.$toast({ status: 3, forceFadeOut: true });
        return;
      }
      this.$dialog({ type: "dialog" });

      this.$fire.$on("caseName", (data, timestamp) => {
        if (data) {
          this.createCase({ data: data, timestamp: timestamp })
            .then(res => {
              this.$toast();
            })
            .catch(res => {
              this.$toast({ status: 1 });
            });
          this.$toast({ status: 2 });
        }
        this.$fire.$off("caseName");
      });
    },
    accountInit() {
      switch (this.$userData["account_level"]) {
        case 1:
          this.graphDisable = false;
          this.searchDisable = false;
          return;
        case 2:
          this.searchDisable = false;
          return;
        case 3:
          this.graphDisable = false;
          return;
      }
    },
    tagDivHeightInit() {
      let tagDiv = this.$refs.tagDiv[0];
      tagDiv.style.height = tagDiv.scrollHeight + "px";
    }
  },
  watch: {
    tagNowSelect: function(val) {
      if (val.length == 0) {
        this.$router.replace("/doc");
      }
    },
    keyWord: function(val) {
      if (val == "") {
        this.$router.replace("/all");
      }
    }
  },
  mounted() {
    this.loading = true;
    this.hideLoading = false;
    this.getWorkSpace().then(() => {
      if (this.loading) {
        this.loading = false;
        setTimeout(() => {
          this.hideLoading = true;
        }, 800);
        this.tagDivHeightInit();
      }
    });
    this.accountInit();
    console.log(this.$userData);
  }
};
</script>

<style lang="scss" scoped>
.body {
  @include flex;
  flex-direction: row;
  position: relative;
  justify-content: flex-start;
  height: 100vh;
  background-color: $back-color;
}
.left-nav {
  @include flex;
  flex-shrink: 0;
  height: 100vh;
  width: 231px;
  background-color: $base-color;
  flex-direction: column;
  justify-content: flex-start;
  .logo {
    height: 97px;
    svg {
      margin-top: 20px;
    }
  }
  .nav {
    @include flex;
    flex-direction: column;
    align-self: stretch;
    li {
      list-style: none;
      align-self: stretch;
      color: $font-base-color;
      font-size: $font-base-size;
      //   height: 40px;
      line-height: 30px;
      // tags
      .tags {
        padding: 0 14px 0 23px;
        position: relative;
        max-height: 400px;
        > div:first-child {
          @include flex;
          justify-content: flex-start;
          padding-top: 4px;
          .icon {
            color: $light-purple;
            font-size: 1.2em;
          }
          .title {
            color: $light-purple;
            font-size: 16px;
          }
        }

        &::before {
          content: "";
          display: block;
          position: absolute;
          top: 0;
          height: 2px;
          width: 182px;
          left: 22px;
          background-color: $border-color;
        }
        .tags-wrapper {
          @include flex;
          flex-direction: row;
          align-content: center;
          justify-content: flex-start;
          flex-wrap: wrap;
          padding-bottom: 10px;
          padding-left: 7px;
        }
      }

      // link
      a {
        @include flex;
        cursor: pointer;
        padding: 5px 0;
        transition: all 300ms;
        border-left: 5px solid transparent;
        justify-content: flex-start;
        width: 100%;
        .addBtn {
          font-size: $font-base-size !important;
          margin-left: auto;
          position: relative;
          width: 20px;
          height: 20px;
          transition: box-shadow 300ms;
          border-radius: 50%;
          color: $dark-purple;
          &:hover {
            color: $light-purple;
          }
          &:active {
            color: $graph-color;
          }
        }
        .icon {
          width: 40px;
          text-align: center;
          font-size: 1.2em;
        }
        .arrow {
          font-size: 12px;
          color: $light-purple;
          margin-left: auto;
          transition: transform 500ms;
          &.up {
            transform: rotate(180deg);
          }
        }
        &:hover {
          background-color: $back-color;
        }
      }
      &.active > a {
        background-color: $back-color;
        border-left: 5px solid $light-purple;
        color: $light-purple;
      }
    }
  }
  .footer {
    @extend .nav;
    margin-top: auto;

    a {
      @include flex;
      position: relative;
      justify-content: flex-start;
      margin: 0 7px;
      padding: 5px 0;
      height: 40px;
      border-radius: 4px;
      line-height: 30px;
      text-decoration: none;
      align-self: stretch;
      font-size: $font-base-size;
      color: $font-base-color;
      transition: all 300ms;
      cursor: pointer;
      &.disabled {
        color: $border-color;
      }
      &.active {
        background-color: $back-color;
      }
      .icon {
        display: inline-block;
        font-size: 1.2em;
        text-align: center;
        width: 40px;
      }
      &:hover {
        background-color: $back-color;
      }
    }
    .copyright {
      @include flex;
      flex-direction: column;
      line-height: 14px;
      font-size: 12px;
      color: #8e9ac5;
      margin: 10px 0 10px;
      & > span:first-child {
        align-self: flex-start;
      }
      & > span:first-child:hover {
        cursor: pointer;
        color: $light-purple;
      }
    }
  }
}
.main-part {
  @include flex;
  flex-grow: 1;
  overflow-y: scroll;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  position: relative;
  padding: 20px 35px 0 15px;
  align-self: stretch;
  .top-nav {
    align-self: stretch;
  }
  .bread-crumbs {
    margin-top: 20px;
    & > span {
      display: inline-block;
      color: $font-base-color;
      font-size: $font-base-size;
      cursor: pointer;
      &:not(:first-child) {
        margin-left: 28px;
        position: relative;
        &:hover {
          text-decoration: underline;
        }
        &::before {
          font-family: "gekko_fonts" !important;
          content: "\e91c";
          display: block;
          position: absolute;
          font-size: 12px;
          transform: translateY(-50%) rotate(-90deg);
          top: 50%;
          left: -20px;
        }
      }
      &.tagSearch {
        margin-left: 5px;
        display: inline;
        &:hover {
          text-decoration: none;
        }
        &::before {
          display: none;
        }
        a {
          position: relative;
          top: 1px;
          margin-left: 5px;
          font-family: "gekko_fonts" !important;
          &:hover {
            color: $light-purple;
          }
        }
      }
    }
  }
  .content {
    align-self: stretch;
    display: flex;
    flex-grow: 1;
    width: 100%;
  }
}
.tagDiv {
  overflow: hidden;
  transition: height 200ms;
}
</style>



// WEBPACK FOOTER //
// src/page/homePage.vue